window.addEventListener('change', function(event) {
    let target;
    if (target = event.target?.closest('form .autoSubmit')) {
        let form = target.closest('form');
        if (form?.querySelector('.alert')) return;
        let submit = form?.querySelector('input.autoSubmitBtn,button.autoSubmitBtn');
        submit?.click();
        if (submit && (!submit.matches('.ajax,.ajax2')) && (!form?.querySelector('.alert'))) {vutAjax.openPreloader();}
    }
}, true);
document.head.insertAdjacentHTML('beforeend', '<style>input.autoSubmitBtn,button.autoSubmitBtn{display:none}</style>')